import script from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&setup=true&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=63b75299&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b75299"]])

export default __exports__